import { BsChevronRight } from "react-icons/bs";
export const Chevron = () => (
  <div className="mx-[.375rem] text-xs font-extrabold text-brand-accent md:mx-2">
    <BsChevronRight className="stroke-1" />
  </div>
);
